import React from 'react';
import { ComponentProvider } from '@tencent/dz-elements';
import { PageModelProvider, EventsProvider } from '../context';
import { PageRenderer } from '../components/pageRenderer';
import '../styles/reset.less';
export function initRuntime(Components, Bricks) {
    return function (props) {
        var model = props.model, events = props.events;
        return (React.createElement(ComponentProvider, { value: Components },
            React.createElement(EventsProvider, { value: events },
                React.createElement(PageModelProvider, { value: model },
                    React.createElement(PageRenderer, { bricks: Bricks }, props.children)))));
    };
}
